import * as React from 'react';

export interface TextAreaProps {
    value?: string;
    max?: number;
    type?: 'light'| 'dark';
    placeholder?: string;
    onChange?: (e: string) => void;
    errors?: string[];
}

export interface TextAreaState {
    value: string;
    count: number;
}

export default class TextArea extends React.Component<TextAreaProps, TextAreaState> {
  constructor(props: TextAreaProps) {
    super(props);

    this.state = {
        value: this.props.value || '',
        count: this.props.value? this.props.value.length : 0
    }
  }

  componentWillReceiveProps(nextProps: TextAreaProps){
      if(nextProps.value != this.props.value && nextProps.value){
          this.setState({value: nextProps.value})
      }
  }

  handleChange = (e) => {
      this.setState({value: e.target.value});

      if(this.props.onChange)
        this.props.onChange(e.target.value);
  }

  public render() {
    return (
      <div className={`${this.props.type || 'light'} text-area`}>
        {this.props.max && <label>{this.state.count}/{this.props.max}</label>}
        <textarea placeholder={this.props.placeholder} className='input-textarea' onChange={this.handleChange} value={this.state.value} >

        </textarea>


      {this.props.errors && <div className='inline-upload-errors'>
                {this.props.errors.map(item => {
                    return <p key={item} className='error-message'>{item}</p>
                })}
            </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/textarea.tsx